(function () {
  function updateBadge(count) {
    var badge = document.querySelector('[data-cart-count]');
    if (!badge) return;
    badge.textContent = count;
    badge.style.display = count > 0 ? '' : 'none';
  }

  var originalFetch = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var isCartChange =
      url.includes('/cart/add') ||
      url.includes('/cart/change') ||
      url.includes('/cart/update');

    var promise = originalFetch.apply(this, arguments);

    if (isCartChange) {
      promise.then(function () {
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) { updateBadge(cart.items.length); });
      });
    }

    return promise;
  };
  
  document.addEventListener('DOMContentLoaded', function () {
  var cartBtn = document.querySelector('[aria-controls="CartDrawer"]');
  var cartDrawer = document.querySelector('cart-drawer');

  if (cartBtn && cartDrawer) {
    cartBtn.addEventListener('click', function () {
      cartDrawer.open(cartBtn);
    });
  }
});

})();
